import { Button, Menu, MenuItem, ListItemText, Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loader from "./loading-screen/Loader";
import { get, postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

const ChangeDeveloper = ({ row, refresh }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [progress, setProgress] = useState(false);
  const [developers, setDevelopers] = useState([]);
  const [selectedDevelopers, setSelectedDevelopers] = useState([]);

  useEffect(() => {
    if (anchorEl) {
      fetchDevelopers();
    }
  }, [anchorEl]);

  const fetchDevelopers = async () => {
    get(
      `${ApiEndpoints.GET_USERS_BIGG}?role=developer`,
      "",
      () => {},
      (res) => {
        setDevelopers(res.data.data);
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (developer) => {
    setSelectedDevelopers((prev) => {
      const isSelected = prev.some((dev) => dev.id === developer.id);
      return isSelected
        ? prev.filter((dev) => dev.id !== developer.id)
        : [...prev, developer];
    });
  };

  const handleSubmit = () => {
    const assignedToIds = selectedDevelopers
      .map((dev) => parseInt(dev.id))
      .join(",");
    // Array of integers
    const assignedNames = selectedDevelopers
      .map((dev) => dev.name.toString())
      .join(","); // Comma-separated string

    const payload = {
      id: row.id,
      assigned_to: parseInt(assignedToIds), // Comma-separated string
      assigned_name: assignedNames, // Comma-separated string
    };

    postJsonData(
      `${ApiEndpoints.EDIT_TASK}/${row.id}`,
      payload,
      setProgress,
      (res) => {
        okSuccessToast(res.data.message);
        if (refresh) refresh();
        handleClose();
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={anchorEl ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl)}
        onClick={handleClick}
        sx={{
          width: "auto",
          height: "30px",
          fontSize: "12px",
          padding: "5px 15px",
          backgroundColor: "#F39C12",
          color: "black",
          textTransform: "capitalize",
          fontWeight: "500",
          border: "1px solid #F39C12",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#F39C12",
            color: "white",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
          },
          transition: "all 0.3s ease",
          mt: 0.5,
        }}
      >
        Assign
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <Loader loading={progress} circleBlue />
        {developers.map((developer) => (
          <MenuItem
            key={developer.id}
            onClick={() => handleCheckboxChange(developer)}
          >
            <Checkbox
              checked={selectedDevelopers.some(
                (dev) => dev.id === developer.id
              )}
            />
            <ListItemText primary={developer?.name} />
          </MenuItem>
        ))}
        <MenuItem>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            fullWidth
          >
            Submit
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ChangeDeveloper;
